import { gql } from '@apollo/client';

export const QUERY_FORMATIONS_BY_TYPE = gql`
  query findFormationByTypeId($id: ID!) {
    findFormationByTypeId(id: $id) {
      name
      desc
      subtitle
      info
      order
      ressources {
        titre
        lien
        media {
          url
        }
        type {
          nom
        }
      }
    }
  }
`;
